import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSeriesById } from "../utils/seriesUtils";
import VideoPlayer from "../components/VideoPlayer";
import { getCurrentUser, toggleFavorite, isFavorite } from "../utils/auth";
import "../styles/styles.css";

const SeriesDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [serie, setSerie] = useState(null);
  const [favorite, setFavorite] = useState(false);
  const user = getCurrentUser(); // ahora es objeto { email, role }

  useEffect(() => {
    const found = getSeriesById(id);
    if (!found) {
      navigate("/");
    } else {
      setSerie(found);
      if (user && user.role === "user") {
        setFavorite(isFavorite(user.email, found.id));
      }
    }
  }, [id, user, navigate]);

  const handleFavorite = () => {
    if (!user) {
      navigate("/login");
      return;
    }
    if (user.role !== "user") {
      // solo usuarios pueden favoritos
      return;
    }
    const updated = toggleFavorite(user.email, serie.id);
    setFavorite(updated.includes(serie.id));
  };

  if (!serie) return null;

  return (
    <div className="series-detail-container">
      <div className="detail-grid">
        <div className="thumbnail-container">
          <img
            src={serie.thumbnail}
            alt={`${serie.title} Thumbnail`}
            className="detail-thumbnail"
          />
        </div>
        <div className="detail-info">
          <h2 className="detail-title">{serie.title}</h2>
          <p className="detail-synopsis">{serie.synopsis}</p>
          <div className="detail-meta">
            <span>Episodios: {serie.episodes}</span>
            <span>Duración: {serie.durationPerEpisode}</span>
            <span>Género: {serie.genre.join(", ")}</span>
            <span>Estreno: {serie.releaseDate}</span>
          </div>
          {serie.uploadedBy && (
            <p className="detail-uploaded">Subido por: {serie.uploadedBy}</p>
          )}
          <button
            className={`btn-primary btn-favorite ${
              favorite ? "favorito" : ""
            }`}
            onClick={handleFavorite}
          >
            {favorite ? "Quitar de Favoritos" : "Agregar a Favoritos"}
          </button>
        </div>
      </div>

      <div className="player-wrapper">
        <VideoPlayer videoUrl={serie.videoUrl} user={user} />
      </div>
    </div>
  );
};

export default SeriesDetail;
